import { Fragment } from "react";
import "./index.css";
function InstallTSPageParis() {
  return (
    <Fragment>
      <div className="content-page">
        <div className="ios-page">
          <div className="content">
            <img
              className="mb-2"
              src="assets/img/paris/android/logo.svg"
              alt=""
            />
            <img
              src="assets/img/paris/install-troubleshooting/txt.svg"
              alt=""
            />
            <img
              src="assets/img/paris/install-troubleshooting/txt2.svg"
              alt=""
            />
            <img
              className="mb-2"
              src="assets/img/paris/install-troubleshooting/android-device.svg"
              alt=""
            />
            <img
              className="mb-2"
              src="assets/img/paris/install-troubleshooting/android-device-desc.svg"
              alt=""
            />
            <img
              className="mb-2"
              src="assets/img/paris/install-troubleshooting/ios-device.svg"
              alt=""
            />
            <img
              className="mb-2"
              src="assets/img/paris/install-troubleshooting/ios-device-desc.svg"
              alt=""
            />
            <img className="mb-2" src="assets/img/paris/android/4.svg" alt="" />
          </div>
        </div>
        <img
          className="footer"
          src="assets/img/paris/android/footer.svg"
          alt=""
        />
      </div>
    </Fragment>
  );
}
export default InstallTSPageParis;
